module.exports = __webpack_public_path__ + "img/FR12619.ed73dc92.png";